import {
  AddExternalPdfTemplateArgs,
  CopyExternalPdfTemplateToPracticeArgs,
  Template,
  TemplateKey,
} from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../../backend/functions/functions'

export const addExternalPdfTemplate = async <Key extends TemplateKey>(
  data: AddExternalPdfTemplateArgs<Key>,
): Promise<Template> => {
  const addTemplateFunc = httpsCallable<AddExternalPdfTemplateArgs<Key>, Template>(
    functions,
    'addExternalPdfTemplate',
  )
  const { data: template } = await addTemplateFunc(data)
  return template
}

export const copyExternalPdfTemplateToPractice = async <Key extends TemplateKey>(
  data: CopyExternalPdfTemplateToPracticeArgs<Key>,
): Promise<Template> => {
  const copyTemplateFunc = httpsCallable<CopyExternalPdfTemplateToPracticeArgs<Key>, Template>(
    functions,
    'copyExternalPdfTemplateToPractice',
  )
  const { data: template } = await copyTemplateFunc(data)
  return template
}
